import {LayersControl, Map, TileLayer, WMSTileLayer} from 'react-leaflet';
import * as React from "react";
import {connect} from "react-redux";
import * as selectors from "../selectors";
import LocationalState, {LocationalConfidence, LocationalRoadObject} from "../LocationalState";
import {LEAFLET_EPSG25833_GEODATA, LEAFLET_EPSG25833_NIB} from "../../../map/NVDBCRS";
import * as WKTParser from "terraformer-wkt-parser";
import MapUtils from "../../../map/map-utils";
import LocationalMapLayer from "./LocationalMapLayer";
import {
    getRoadSegments,
    GetRoadSegments,
    SetSelectedRoadObjects,
    setSelectedRoadObjects,
    toggleSelectedRoadObject,
    ToggleSelectedRoadObject
} from "../actions";
import {RoadSegmentLayer} from "./RoadSegmentLayer";
import L, {latLng, LatLng, LatLngBounds, LatLngTuple, LayersControlEvent} from "leaflet";
import ZoomingFeatureGroup from "./ZoomingFeatureGroup";
import classNames = require("classnames");
import DragSelect from "./DragSelect";
import {GeometryObject} from "geojson";
import {LocationalAnchorLayer} from "./LocationalAnchorLayer";
import AutoZoomButton from "../../contract-features-3/components/map/AutoZoomButton";
import GrayScaleButton from "../../contract-features-3/components/map/GrayScaleButton";

const {BaseLayer} = LayersControl;

interface TagProps {
}

interface DispatchProps {
    doToggleSelectedRoadObject: ToggleSelectedRoadObject,
    doGetRoadSegments: GetRoadSegments,
    doSetSelectedRoadObjects: SetSelectedRoadObjects,
}

interface StateProps {
    visibleRoadObjects: LocationalRoadObject[],
}

type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        visibleRoadObjects: selectors.visibleRoadObjects(state),
    };
};

const mapDispatchToProps: DispatchProps = ({
    doToggleSelectedRoadObject: toggleSelectedRoadObject,
    doGetRoadSegments: getRoadSegments,
    doSetSelectedRoadObjects: setSelectedRoadObjects,
});

interface LocationalMapState {
    defaultLat: number,
    defaultLng: number,
    zoomLevel: number,
    autoZoomEnabled: boolean,
    grayscaleEnabled: boolean,
    crs: L.Proj.CRS,
}

class LocationalMapComponent extends React.Component<Props, LocationalMapState> {
    private mapRef: Map;

    constructor(props: Props) {
        super(props);
        this.state = {
            defaultLat: 63.43,
            defaultLng: 10.40,
            zoomLevel: 4,
            autoZoomEnabled: true,
            grayscaleEnabled: false,
            crs: LEAFLET_EPSG25833_GEODATA,
        }
        this.setMapRef = this.setMapRef.bind(this);
    }

    render() {
        const {visibleRoadObjects} = this.props;
        let zoomClose = this.state.zoomLevel > 14;

        let mapClasses = classNames({
            "locational-map": true,
            "zoom-close": zoomClose,
            "zoom-far": !zoomClose,
            "grayscale": this.state.grayscaleEnabled,
        });

        if (this.state.crs === LEAFLET_EPSG25833_GEODATA) {
            return (<Map
                className={mapClasses}
                crs={this.state.crs}
                center={this.getCenter()}
                zoom={this.state.zoomLevel}
                onbaselayerchange={e => this.baseLayerChanged(e)}
                onmovestart={(e) => this.handleMoveStart(e)}
                ondragend={(e) => this.handleMoveEnd(e)}
                onresize={(e) => this.handleMoveEnd(e)}
                onzoomend={(e) => this.handleZoomEnd(e)}
                doubleClickZoom={"center"}
                ref={this.setMapRef}>

                <GrayScaleButton toggleGrayScale={() => this.toggleGrayScale()} grayscaleEnabled={this.state.grayscaleEnabled} position='bottomleft'/>

                <LayersControl position='bottomleft'>
                    <BaseLayer name='Geodata Online' checked>
                        <TileLayer
                            maxZoom={20}
                            minZoom={3}
                            maxNativeZoom={16}
                            attribution='NVDB'
                            url='https://nvdbcache.geodataonline.no/arcgis/rest/services/Trafikkportalen/GeocacheTrafikkJPG/MapServer/tile/{z}/{y}/{x}'
                        />
                    </BaseLayer>
                    <BaseLayer name='Norkart WebAtlas'>
                        <WMSTileLayer
                            maxZoom={20}
                            minZoom={0}
                            layers='WEBATLASNorge:Norge'
                            format='image/png'
                            url={'/rest/map/webatlas'}
                            attribution="Webatlas"
                        />
                    </BaseLayer>
                    <BaseLayer name='Norge i Bilder'>
                        <TileLayer
                            maxZoom={17}
                            minZoom={0}
                            layers='ortofoto'
                            format='image/jpeg'
                            url={'https://opencache3.statkart.no/gatekeeper/gk/gk.open_nib_utm33_wmts_v2?layer=Nibcache_UTM33_EUREF89_v2&style=default&tilematrixset=default028mm&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fjpeg&TileMatrix={z}&TileCol={x}&TileRow={y}'}
                            attribution="GeoNorge"
                        />
                    </BaseLayer>
                </LayersControl>

                {this.getAdditionalMapLayersAndButtons(visibleRoadObjects)}
            </Map>);
        } else if (this.state.crs === LEAFLET_EPSG25833_NIB) {
            return (
                <>
                    <p style={{height: 0, margin: 0}}>easter egg</p>
                    <Map
                        className={mapClasses}
                        crs={this.state.crs}
                        center={this.getCenter()}
                        zoom={this.state.zoomLevel}
                        onbaselayerchange={e => this.baseLayerChanged(e)}
                        onmovestart={(e) => this.handleMoveStart(e)}
                        ondragend={(e) => this.handleMoveEnd(e)}
                        onresize={(e) => this.handleMoveEnd(e)}
                        onzoomend={(e) => this.handleZoomEnd(e)}
                        doubleClickZoom={"center"}
                        ref={this.setMapRef}>

                        <GrayScaleButton toggleGrayScale={() => this.toggleGrayScale()} grayscaleEnabled={this.state.grayscaleEnabled} position='bottomleft'/>

                        <LayersControl position='bottomleft'>
                            <BaseLayer name='Geodata Online'>
                                <TileLayer
                                    maxZoom={20}
                                    minZoom={3}
                                    maxNativeZoom={16}
                                    attribution='NVDB'
                                    url='https://nvdbcache.geodataonline.no/arcgis/rest/services/Trafikkportalen/GeocacheTrafikkJPG/MapServer/tile/{z}/{y}/{x}'
                                />
                            </BaseLayer>
                            <BaseLayer name='Norkart WebAtlas'>
                                <WMSTileLayer
                                    maxZoom={20}
                                    minZoom={0}
                                    layers='WEBATLASNorge:Norge'
                                    format='image/png'
                                    url={'/rest/map/webatlas'}
                                    attribution="Webatlas"
                                />
                            </BaseLayer>
                            <BaseLayer name='Norge i Bilder' checked>
                                <TileLayer
                                    maxZoom={17}
                                    minZoom={0}
                                    layers='ortofoto'
                                    format='image/jpeg'
                                    url={'https://opencache3.statkart.no/gatekeeper/gk/gk.open_nib_utm33_wmts_v2?layer=Nibcache_UTM33_EUREF89_v2&style=default&tilematrixset=default028mm&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fjpeg&TileMatrix={z}&TileCol={x}&TileRow={y}'}
                                    attribution="GeoNorge"
                                />
                            </BaseLayer>
                        </LayersControl>

                        {this.getAdditionalMapLayersAndButtons(visibleRoadObjects)}
                    </Map>
                </>
            )
        }
    }

    setMapRef(element: Map) {
        this.mapRef = element;
    }

    getCenter = (): LatLng => {
        if (this.mapRef) {
            return this.mapRef.leafletElement.getCenter();
        } else {
            return latLng(this.state.defaultLat, this.state.defaultLng);
        }
    }

    getAdditionalMapLayersAndButtons(visibleRoadObjects: LocationalRoadObject[]) {
        return <>
            <DragSelect position='topleft'
                        onSelection={this.onSelectFeatures.bind(this)}/>

            <RoadSegmentLayer/>

            <ZoomingFeatureGroup enableAutoZoom={this.state.autoZoomEnabled} zoomHook={visibleRoadObjects.length}>
                {this.createRoadObjectLayers()}
            </ZoomingFeatureGroup>

            <LocationalAnchorLayer />
            <AutoZoomButton toggleAutoZoom={() => this.toggleAutoZoom()} autoZoomEnabled={this.state.autoZoomEnabled}/>
        </>
    }

    baseLayerChanged = (e: LayersControlEvent) => {
        this.setBaseLayerCrs(e);

        // Trigger componentDidUpdate
        this.setState({
            autoZoomEnabled: this.state.autoZoomEnabled
        });
    }

    setBaseLayerCrs = (e: LayersControlEvent) => {
        const newLayerName = e.name;
        if (newLayerName === "Norge i Bilder") {
            this.setState({
                crs: LEAFLET_EPSG25833_NIB
            })
        }
        if (newLayerName === "Geodata Online") {
            this.setState({
                crs: LEAFLET_EPSG25833_GEODATA
            })
        }
    }

    toggleGrayScale() {
        this.setState({
            grayscaleEnabled: !this.state.grayscaleEnabled
        })
    }

    onSelectFeatures(bounds: LatLngBounds){
        let containedROs = this.props.visibleRoadObjects.filter(ro => {
            let roGeometry: GeometryObject = MapUtils.convertUtm33ToWgs84(WKTParser.parse(ro.geometry.wkt));
            let pos: LatLngTuple = MapUtils.geoJsonToLatLng(roGeometry);
            return bounds.contains(pos);
        });

        let roids = containedROs.map(ro => {
            return ro.id
        });

        this.props.doSetSelectedRoadObjects(roids);
    }

    handleZoomEnd(e: L.LeafletEvent){
        this.setState({zoomLevel: e.target._zoom});
        this.handleMoveEnd(e);
    }

    handleMoveStart(e: L.LeafletEvent) { }

    toggleAutoZoom() {
        this.setState({
                autoZoomEnabled: !this.state.autoZoomEnabled
            }
        )
    }

    handleMoveEnd(e: L.LeafletEvent) {
        const zoomLevel = e.target.getZoom();
        if (zoomLevel >= 15) {
            const bounds = e.target.getBounds() as LatLngBounds;
            const southWest = bounds.getSouthWest();
            const northEast = bounds.getNorthEast();
            const southWestPositionJson = MapUtils.wgs84ToUtm33(southWest);
            const northEastPositionJson = MapUtils.wgs84ToUtm33(northEast);
            const southWestX = southWestPositionJson.easting;
            const southWestY = southWestPositionJson.northing;
            const northEastX = northEastPositionJson.easting;
            const northEastY = northEastPositionJson.northing;
            this.props.doGetRoadSegments(southWestX, southWestY, northEastX, northEastY);
        }
    }

    createRoadObjectLayers() {
        let {visibleRoadObjects} = this.props;

        let layers = visibleRoadObjects
            .filter(ro => !!ro.geometry?.wkt)
            .map(ro => {
                let featurePosUtm33 = WKTParser.parse(ro.geometry.wkt);
                let geoPositionts = MapUtils.convertUtm33ToWgs84(featurePosUtm33);
                let confidence = LocationalConfidence[ro.locationalConfidence ?? 0];

                return (
                    <LocationalMapLayer key={ro.id}
                                        geometry={geoPositionts}
                                        roadObject={ro}
                                        roadObjectClicked={() => this.handleRoadObjectClick(ro.id)}
                                        isSelected={ro.isSelected}
                                        confidence={confidence}
                    />
                )
        });

        return layers;
    }

    handleRoadObjectClick(roId: string) {
        this.props.doToggleSelectedRoadObject(roId);
    };

}

export const LocationalMap = connect(mapStateToProps, mapDispatchToProps)(LocationalMapComponent);